// app/router.options.ts

import type {RouterOptions} from '@nuxt/schema'
import {useLogger} from '~/utils/logger'

const logger = useLogger('router.options.ts')

export default <RouterOptions>{
  routes: (_routes) => {
    // Access tenant data differently for SSR and CSR
    const {subdomain} = useTenant()

    logger.debug('subdomain', subdomain)

    if (!subdomain.value) {
      logger.debug('No subdomain')
      // No tenant means we're running the SaaS web app (non-tenant routes)
      return _routes.filter((route) => !route.path.startsWith('/=/'))
    }

    // It's a tenant, so return new set of routes filtered from _routes
    const userRoute = _routes.filter((i) => i.path.includes("/:slug"))
    const userRouteMapped = userRoute.map((i) => ({
      ...i,
      path: i.path === "/:slug()" ? i.path.replace("/:slug()", "/") : i.path.replace("/:slug()/", "/"),
    }))

    logger.debug('userRouteMapped', userRouteMapped)

    return userRouteMapped
  }
}
